import { useQuery } from "@tanstack/react-query";
import { useHotel } from "@/hooks/useHotel";
import {
  activityLogService,
  ActivityLogFilters,
} from "@/services/activityLogService";

export const useActivityLogs = (filters?: ActivityLogFilters) => {
  const { hotelId } = useHotel();
  const enabled = Boolean(hotelId && filters);

  const query = useQuery({
    queryKey: ["dashboard", "activityLogs", hotelId, filters] as const,
    queryFn: () =>
      activityLogService.findAll({
        ...filters,
      }),
    enabled,
    staleTime: 30_000,
  });

  return {
    logs: query.data?.data ?? [],
    total: query.data?.total ?? 0,
    isLoading: query.isLoading,
  };
};
